export default __webpack_public_path__ + "static/media/LANCER-LIRICAL.6e85cc34.png";